<template>
  <div :class="['tabs-container']" ref="tabBoxContainer">
    <div class="sk-spinner sk-spinner-wave" v-show="loading">
      <div class="sk-rect1"></div>
      <div class="sk-rect2"></div>
      <div class="sk-rect3"></div>
      <div class="sk-rect4"></div>
      <div class="sk-rect5"></div>
    </div>

    <slot name="tools" />
    <ul class="nav nav-tabs" role="tablist">
      <slot name="tablist" />
    </ul>
    <div class="tab-content ">
      <slot name="tabcontent" />
    </div>
  </div>
</template>

<script>
import EventBus from '@/utils/eventBus'

export default {
  name: 'TabbedBox',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    // Query Navigation - If true, use anchors in query to navigate to a tab on mount
    useQueryNavigation: {
      type: Boolean,
      default: false
    },
    tabs: []
  },
  provide() {
    return {
      tabbedBox: this
    }
  },
  data() {
    return {
      registeredTabItems: [],
      registeredTabPageItems: [],
    }
  },
  mounted() {
    EventBus.on(EventBus.EventTypes.pageRefreshed, this.pageRefreshed)

    if(this.useQueryNavigation && this.$route.hash) {
      var hashTabId = (this.$route.hash + '').replace('#', '')
      var tabItem = this.registeredTabItems.find(tabItem => tabItem.tabid == hashTabId)
      if(tabItem) {
        this.$nextTick(() => {
          tabItem.show();
        })
      }
    }
  },
  beforeDestroy() {
    EventBus.off(EventBus.EventTypes.pageRefreshed, this.pageRefreshed)
  },

  methods: {
    pageRefreshed() {
      this.registeredTabItems[0].show()
    },
    registerTabItem(item) {
      if(!this.registeredTabItems.find(i => i === item)) {
        this.registeredTabItems.push(item)
        item.$once('hook:destroyed', () => {
          this.unregisterTabItem(item)
        })
      }
    },
    unregisterTabItem(item) {
      this.registeredTabItems = this.registeredTabItems.slice().filter(i => i !== item)
    },
    registerTabPageItem(item) {
      if(!this.registeredTabPageItems.find(i => i === item)) {
        this.registeredTabPageItems.push(item)
        item.$once('hook:destroyed', () => {
          this.unregisterTabPageItem(item)
        })
      }
    },
    unregisterTabPageItem(item) {
      this.registeredTabPageItems = this.registeredTabPageItems.slice().filter(i => i !== item)
    },
    displayErrors() {
      this.$nextTick(() => {
        try {

          this.registeredTabItems.forEach((tab, index) => {
            let tabPage = this.registeredTabPageItems.find(tabPage => tabPage.tabid == tab.tabid)
            if(tabPage)
              tab.displayErrors(tabPage)
          })

        } catch(err) {
        }
      })
    }
  }
}
</script>